import Axios from "axios";
import {
    SET_PRODUCT_MAP_LIST,
    UNSET_PRODUCT_MAP_LIST,
  } from "@/store/mutation-types";
import { saveUpdateProductMap, getProductMapList } from "@/store/api";
// initial state
const state = {
  getProductMapList: [],
};

const getters = {
  getProductMapList(state) {
    return state.getProductMapList;
  },
};
const mutations = {
  [SET_PRODUCT_MAP_LIST](state, data) {
    state.getProductMapList = data;
  },
  [UNSET_PRODUCT_MAP_LIST](state) {
    state.getProductMapList = [];
  },
};

const actions = {

  saveUpdateProductMap({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateProductMap, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getProductMapList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getProductMapList, data)
        .then(function (response) {
          commit('SET_PRODUCT_MAP_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_PRODUCT_MAP_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
